class GedeonProductCardWishlist {
  constructor() {
    this.storageKey = 'gedeon:wishlist';
    this.buttons = [];
  }

  init() {
    this.buttons = Array.from(document.querySelectorAll('[data-gedeon-wishlist]'));
    if (!this.buttons.length) return;

    const saved = this.readSaved();
    this.buttons.forEach((button) => {
      const handle = button.getAttribute('data-product-handle');
      if (!handle) return;

      this.setPressed(button, saved.includes(handle));
      button.addEventListener('click', () => this.toggle(button, handle));
    });
  }

  readSaved() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(this.storageKey) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  writeSaved(saved) {
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(saved));
    } catch {
      return;
    }
  }

  setPressed(button, pressed) {
    button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    button.classList.toggle('is-active', pressed);
  }

  toggle(button, handle) {
    const saved = this.readSaved();
    const exists = saved.includes(handle);
    const next = exists ? saved.filter((item) => item !== handle) : [...saved, handle];

    this.writeSaved(next);
    this.setPressed(button, !exists);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new GedeonProductCardWishlist().init();
});

;/* GEDEON REDESIGN 2026-09 — assets/gedeon-redesign.js (defer) */
(function () {
  'use strict';

  /* 1. Kolekcja: opis przycięty do 2 linii + „Czytaj więcej” */
  function initCollectionIntro() {
    var desc = document.querySelector('.editorial-collection-hero__description');
    if (!desc || desc.dataset.gdnInit) return;
    desc.dataset.gdnInit = '1';
    desc.classList.add('gdn-clamp');
    if (desc.scrollHeight <= desc.clientHeight + 4) { desc.classList.remove('gdn-clamp'); return; }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gdn-readmore';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Czytaj więcej';
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('gdn-clamp') === false;
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Zwiń' : 'Czytaj więcej';
    });
    desc.insertAdjacentElement('afterend', btn);
  }

  /* 2. Karta produktu: przyklejony pasek „Do koszyka” */
  function initStickyAtc() {
    var main = document.querySelector('.product__info-container .product-form__submit');
    if (!main || document.querySelector('.gdn-sticky-atc')) return;

    var titleEl = document.querySelector('.gedeon-product-summary__title, .product__title h1');
    var priceEl = document.querySelector('.product__info-container [id^="price-"] .price-item--last, .product__info-container [id^="price-"] .price-item');
    var imgEl = document.querySelector('.product__media-item img');

    var bar = document.createElement('div');
    bar.className = 'gdn-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="gdn-sticky-atc__inner">' +
        (imgEl ? '<img class="gdn-sticky-atc__img" alt="" loading="lazy">' : '') +
        '<div class="gdn-sticky-atc__meta"><div class="gdn-sticky-atc__title"></div><div class="gdn-sticky-atc__price"></div></div>' +
        '<button type="button" class="gdn-sticky-atc__btn" tabindex="-1">Do koszyka</button>' +
      '</div>';
    if (imgEl) bar.querySelector('img').src = imgEl.currentSrc || imgEl.src;
    bar.querySelector('.gdn-sticky-atc__title').textContent = titleEl ? titleEl.textContent.trim() : '';

    var btn = bar.querySelector('.gdn-sticky-atc__btn');
    function sync() {
      var p = document.querySelector('.product__info-container [id^="price-"] .price-item--last, .product__info-container [id^="price-"] .price-item');
      bar.querySelector('.gdn-sticky-atc__price').textContent = p ? p.textContent.trim() : '';
      btn.disabled = main.disabled;
      btn.textContent = main.disabled ? 'Wyprzedane' : 'Do koszyka';
    }
    sync();
    btn.addEventListener('click', function () { if (!main.disabled) main.click(); });
    document.body.appendChild(bar);

    // Synchronizacja po zmianie wariantu / ceny
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(main, { attributes: true, attributeFilter: ['disabled'] });
      var priceWrap = document.querySelector('.product__info-container [id^="price-"]');
      if (priceWrap) new MutationObserver(sync).observe(priceWrap, { childList: true, subtree: true, characterData: true });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        btn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('gdn-sticky-on', show);
      }, { threshold: 0 });
      io.observe(main);
    }
  }

  function init() { initCollectionIntro(); initStickyAtc(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
